<template>
  <div id="BookPage">
    <BookInfo @book-loaded="setBookSeo" />
    <!-- <BookContent /> -->
  </div>
</template>

<script>
import BookInfo from "../components/BookPage/BookInfo.vue";

export default {
  name: "BookPage",

  components: {
    BookInfo,
  },

  methods: {
    /**
     * 建立或更新一般 meta 標籤
     * 例如 description、robots、twitter:card
     */
    setMetaTag(name, content) {
      if (!content) return;

      let meta = document.querySelector(`meta[name="${name}"]`);

      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("name", name);
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", content);
    },

    /**
     * 建立或更新 Open Graph 標籤
     * 例如 og:title、og:description、og:image
     */
    setOgTag(property, content) {
      if (!content) return;

      let meta = document.querySelector(`meta[property="${property}"]`);

      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute("property", property);
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", content);
    },

    /**
     * 建立或更新 canonical
     */
    setCanonical(url) {
      if (!url) return;

      let canonical = document.querySelector('link[rel="canonical"]');

      if (!canonical) {
        canonical = document.createElement("link");
        canonical.setAttribute("rel", "canonical");
        document.head.appendChild(canonical);
      }

      canonical.setAttribute("href", url);
    },

    /**
     * 將 Google Sheet 圖片欄位轉成完整網址
     */
    resolveImageUrl(imageValue) {
      const image = String(imageValue || "").trim();

      if (!image) return "";

      if (/^https?:\/\//i.test(image)) {
        return image;
      }

      if (image.startsWith("//")) {
        return `https:${image}`;
      }

      return `https://www.union.com.tw/${image.replace(/^\/+/, "")}`;
    },

    /**
     * 統一處理摘要文字
     */
    createDescription(bookTitle, summary) {
      const rawSummary = String(summary || "")
        .replace(/\s+/g, " ")
        .trim();

      const maxLength = 150;

      if (rawSummary) {
        return rawSummary.length > maxLength
          ? `${rawSummary.slice(0, maxLength).trim()}…`
          : rawSummary;
      }

      return `${bookTitle} 為聯洋文化代理之美國同步英文教材，適合雙語學校、國際學校與英文教學使用。`;
    },

    /**
     * BookInfo 資料載入完成後，統一更新 SEO
     */
    setBookSeo(book = {}) {
      const bookTitle =
        String(book.title_en || book.title_zh || "聯洋文化教材").trim() ||
        "聯洋文化教材";

      const seoTitle = `${bookTitle}｜美國同步英文教材｜聯洋文化`;

      const bookDescription = this.createDescription(
        bookTitle,
        book.summary_zh || book.summary_en,
      );

      const canonicalUrl = `${window.location.origin}${window.location.pathname}`;

      const ogImage = this.resolveImageUrl(book.img);

      // Google 搜尋標題
      document.title = seoTitle;

      // 基本 SEO
      this.setMetaTag("description", bookDescription);
      this.setMetaTag("robots", "index, follow");

      // Canonical
      this.setCanonical(canonicalUrl);

      // Open Graph：LINE、Facebook、Messenger、Slack 等
      this.setOgTag("og:title", seoTitle);
      this.setOgTag("og:description", bookDescription);
      this.setOgTag("og:type", "website");
      this.setOgTag("og:url", canonicalUrl);
      this.setOgTag("og:site_name", "聯洋文化");
      this.setOgTag("og:locale", "zh_TW");

      if (ogImage) {
        this.setOgTag("og:image", ogImage);
        this.setOgTag("og:image:secure_url", ogImage);
        this.setOgTag("og:image:alt", `${bookTitle} 教材封面`);
      }

      // Twitter / X 分享卡片
      this.setMetaTag(
        "twitter:card",
        ogImage ? "summary_large_image" : "summary",
      );
      this.setMetaTag("twitter:title", seoTitle);
      this.setMetaTag("twitter:description", bookDescription);

      if (ogImage) {
        this.setMetaTag("twitter:image", ogImage);
        this.setMetaTag("twitter:image:alt", `${bookTitle} 教材封面`);
      }
    },
  },
};
</script>

<style>
.ProductImg {
  width: 100%;
}

.infoListTiTle {
  margin: 17px;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
}

.infoList {
  margin: 15px;
  text-align: left;
}

.textinfo {
  text-align: left;
}

.TiTle {
  margin: 10px;
  font-weight: 550;
  text-align: left;
}
</style>
